// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__39dC-","label":"CategoryService_label__2amDv","location":"CategoryService_location__2vWPQ"};